import { g as __rest, b as __assign } from '../../../../tslib.es6-14c74580.js';
import React__default from 'react';

var ListItemBoxText = function (_a) {
    var text = _a.text, _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.size, size = _c === void 0 ? 'small' : _c, _d = _a.className, className = _d === void 0 ? '' : _d, children = _a.children, rest = __rest(_a, ["text", "title", "size", "className", "children"]);
    return (React__default.createElement("p", __assign({ className: "list-item-history-inner-item-txt ".concat(size, " ").concat(className), title: title || text }, rest), children || text));
};
var ListBoxItemImg = function (_a) {
    var imageSrc = _a.imageSrc, _b = _a.alt, alt = _b === void 0 ? 'img' : _b, onClick = _a.onClick, rest = __rest(_a, ["imageSrc", "alt", "onClick"]);
    return (React__default.createElement("div", __assign({ className: 'history-checked-image-b', onClick: onClick }, rest, { style: onClick ? { cursor: 'pointer' } : {} }),
        React__default.createElement("div", { className: 'checked-image-b' },
            React__default.createElement("img", { className: 'history-checked-img', src: imageSrc, alt: alt }))));
};

export { ListBoxItemImg, ListItemBoxText };
